import { render, staticRenderFns } from "./access-component.vue?vue&type=template&id=68561bb5&"
import script from "./access-component.vue?vue&type=script&lang=js&"
export * from "./access-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports